export class TadpoleTotalData {
  totalCount: number;
  data: any[];


  constructor(totalCount: number, data: any[]) {
    this.totalCount = totalCount;
    this.data = data;
  }
}
